import { Stack } from '@mui/joy';
import { useNavigate } from 'react-router-dom';
import { FormProvider, useForm } from "react-hook-form";
import { FormButtons } from '@/components/FormButtons';
import { yupResolver } from "@hookform/resolvers/yup"
import { useParams } from "react-router-dom";
import {recipeSchema, fieldsByTab, toRecipeFormData} from "@/features/recipes/schema.js";
import { PageHeader } from '@/components/PageHeader.jsx';
import { TabPanel } from '@mui/joy';
import { TabsSegmented } from '@/components/TabsSegmented.jsx';
import { DetailsFormTab } from '@/features/recipes/components/DetailsFormTab.jsx';
import { IngredientsFormTab } from '@/features/recipes/components/IngredientsFormTab.jsx';
import { InstructionsFormTab } from '@/features/recipes/components/InstructionsFormTab.jsx';
import { EquipmentFormTab } from '@/features/recipes/components/EquipmentFormTab.jsx';
import { useFormTab } from '@/hooks/useFormTabs.js';

const tabs = ['Details', 'Ingredients', 'Instructions', 'Equipment'];

export function RecipeForm({ title, data, save, saveResult, onSaved }) {
  const { householdId } = useParams();
  const navigate = useNavigate();

  const form = useForm({
    defaultValues: toRecipeFormData(data),
    resolver: yupResolver(recipeSchema)
  });

  async function onSubmit(data) {
    const result = await save(data);
    if (result.error) {
      console.error(result.error);
    } else if (onSaved) {
      onSaved(result.data.data);
    } else {
      navigate(`/h/${householdId}/recipes/${result.data.data.id}`);
    }
  }

  const { onFormSubmit, ...tabsProps } = useFormTab({ form, fieldsByTab, onSubmit });

  return (
    <FormProvider {...form}>
      <form onSubmit={onFormSubmit}>   
        <Stack gap={2} direction="column">
          <PageHeader title={title}>
            <FormButtons isSaving={saveResult.isLoading} saveLabel="Save Recipe" order="rtl" />
          </PageHeader>        

          <TabsSegmented tabs={tabs} {...tabsProps} sx={{ mt: { xs: 1, md: 0 } }}>
            <TabPanel value={0}>
              <DetailsFormTab />
            </TabPanel>
            <TabPanel value={1}>
              <IngredientsFormTab />
            </TabPanel>
            <TabPanel value={2}>
              <InstructionsFormTab />
            </TabPanel>
            <TabPanel value={3}>
              <EquipmentFormTab />
            </TabPanel>
          </TabsSegmented>       
        </Stack>     
      </form >
    </FormProvider>
  );
}
